export default __webpack_public_path__ + "static/media/sliderPart5.72652cce.png";